module.exports = __webpack_public_path__ + "static/media/logo.8599235f.png";